//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import Status from '~/components/partials/status'
export default {
  name: 'UserDropdown',
  components: { Status },
  props: {
    verification: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    statusObj () {
      let obj = {
        title: '<span>' + this.$t('common.level') + ' <span>' + this.user.level,
        status: 'status-active'
      }
      if (this.user.status === 'USR_NEW') {
        obj = {
          title: this.$t('landing.sidebar.needToLevelUp'),
          status: 'status-info'
        }
      }
      if (this.user.status === 'USR_LEVEL_UP') {
        obj = {
          title: '<span>' + this.$t('landing.sidebar.checkLevel') + ' </span>' + this.user.level,
          status: 'status-processing'
        }
      }
      if (this.user.status === 'USR_ACTIVE') {
        if (this.verification === 'REJECTED') {
          obj = {
            title: this.$t('landing.sidebar.needToEdit'),
            status: 'status-rejected',
            icon: 'ico-times'
          }
        }
        if (this.verification === 'REQUESTED') {
          obj = {
            title: '<span>' + this.$t('landing.sidebar.checkLevel') + ' </span>' + this.user.level,
            status: 'status-processing'
          }
        }
      }
      return obj
    }
  }
}
